PegasusTemplate.SliderController = Ember.Controller.extend({
  needs: ['application'],
  contentBinding: Ember.Binding.oneWay('controllers.application.sliderTarget'),
  slideValueBinding: 'controllers.application.slideValue'
});
